// extracted by mini-css-extract-plugin
export var button = "_kr-0";